import {PageView} from "./PageView.js";
import {Layout} from "../components/layout/Layout.js";
import {checkDuplicateEmail} from "../../../apiCall/signup/index.js";
import {InputErrorHandler} from "../util/input-error-handler/index.js";
import {addEmail, collectGtm, getEmail, isGuestUser} from "../store.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {ERROR_CODE} from "../constant.js";
import {Header} from "../components/Header.js";
import {EmailInput} from "../components/input/EmailInput.js";

export class EmailInputView extends PageView {

    renderLayout() {
        const { mainText = '', subText = ''} = this.$props;
        this.$props.Layout = new Layout(this.$target, {
            isAppend: true,
            sectionId : `emailInputSection`,
            mainText,
            subText,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.moveEmailAuthView.bind(this)
            }
        });
    }


    renderComponents() {
        if(!this.$props.Layout) {
            return;
        }
        new Header(this.$props.Layout.getHeaderLayer(), {
            isShowLoginBtn: true,
            isShowPrevBtn: true
        });
        this.$props.EmailInput = new EmailInput(this.$props.Layout.getMainLayer(), {
            inputId: `emailInput`,
            $posTarget: $("#subTxt"),
            isAfter: true,
            isLast: true,
            emailValue : getEmail(),
            submit: this.moveEmailAuthView.bind(this),
        });
    }


    async moveEmailAuthView() {
        if (!this.$props.EmailInput.inputValidate()) {
            return;
        }
        const email = this.$props.EmailInput.getInputValue();
        const dat = await checkDuplicateEmail(email);
        if (this.isCompanyRegisterError(dat['ERR_CD'])) {
            InputErrorHandler.activeErrorModeAboutInput(this.$props.EmailInput.get$Input(), i18next.t(login.accountAlreadyJoin));
            return;
        }

        if (this.isDuplicateEmail(dat['ERR_CD'])) {
            InputErrorHandler.activeErrorModeAboutInput(this.$props.EmailInput.get$Input(), i18next.t(common.occupy, {val: $t(dictionary.email)}));
            return;
        }
        addEmail(email);
        SignUpViewChanger.loadEmailAuthView();
    }

    isCompanyRegisterError(errorCode) {
        return Mutil.n2v(errorCode) === ERROR_CODE.EXIST_COMPANY_INVIT;

    }
    isDuplicateEmail(errorCode) {
        return Mutil.n2v(errorCode) !== ERROR_CODE.SUCCESS;
    }

}